import {
    GET_DASHBOARD_LIST,
    GET_DASHBOARD_LIST_SUCCESS,
    GET_DASHBOARD_LIST_FAILURE,
    SET_FIM_FILTER_DATES,
    RESET_DEFAULT_DATE,
} from '../actions';

const initialState = {
    loading: true,
    districtList: [],
    districtFilterList: [],
    defaultDate: null,
    fimStartDate: null,
    fimEndDate: null,
    totalNoOfDistricts: 0,
    error: null,
};

const dashboardListReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_DASHBOARD_LIST:
            return { ...state, loading: true, error: null };
        case GET_DASHBOARD_LIST_SUCCESS: {
            return {
                ...state,
                loading: false,
                districtList: action.payload,
                districtFilterList: action.districtFilterList,
                defaultDate: action.defaultDate || null,
                totalNoOfDistricts: parseInt(action.totalNoOfDistricts, 10) || 0,
                error: null,
            };
        }
        case GET_DASHBOARD_LIST_FAILURE:
            return { ...state, loading: false, error: action.payload?.error };
        case SET_FIM_FILTER_DATES:
            return {
                ...state,
                fimStartDate: action.payload.fimStartDate !== undefined ? action.payload.fimStartDate : state.fimStartDate,
                fimEndDate: action.payload.fimEndDate !== undefined ? action.payload.fimEndDate : state.fimEndDate,
            };
        case RESET_DEFAULT_DATE:
            return { ...state, defaultDate: initialState.defaultDate };
        default:
            return state;
    }
};

export default dashboardListReducer;
